<template>
    <div class="tab-menu--main-settings">
        <div class="tab-menu--main-setting" @click="showMainSetting('uploadescudo')">
            upload escudo
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        showMainSetting(setting) {
            this.$emit('showMainSetting', setting);
        }
    }
}
</script>
<style lang="less">
</style>